// extracted by mini-css-extract-plugin
module.exports = {"bodyText":"styles_bodyText__1lXcX","errorText":"styles_errorText__1cw7J"};